module.exports = __webpack_public_path__ + "static/img/monitor-logo.28468a92.png";